import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { SingleValue } from 'react-select';
import Background from '@assets/sign-in-bg.png';
import { Option } from '@components/form-select/form-select';
import { Logo } from '@components/logo/logo';
import { Flex } from '@components/utility/flex';
import { ReactComponent as Arrow } from './assets/arrow.svg';
import { StyledPrivacyPolicyLayout } from './privacy-policy-layout.styled';
import { getAuthService } from "@asd-stan/auth/infrastructure/getters";
import { useNavigate } from "react-router-dom";
import { parseToken } from "@asd-stan/helpers/app-utils";
import { AccessTokenPayload } from "@asd-stan/auth/domain/auth.entity";

interface AuthLayoutProps {
    children: React.ReactNode;
}

export const PrivacyPolicyLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    const { t } = useTranslation();
    const authService = getAuthService();
    const navigate = useNavigate();

    const { accessToken }: Storage = localStorage;

    const options: Option[] = [
        { value: 'en', label: t('auth.authLayout.enLabel') },
        { value: 'fr', label: t('auth.authLayout.frLabel') },
    ];

    const [selectedLanguage, setSelectedLanguage] = useState<Option>({
        value: 'en',
        label: t('auth.authLayout.enLabel'),
    });

    const handleLanguageChange = (selectedOption: SingleValue<Option>) => {
        setSelectedLanguage(selectedOption as Option);
    };

    const handleLogout = () => {
        authService.handleLogout();
        navigate("/signin");
    }

    if (accessToken) {
        const payload = parseToken<AccessTokenPayload>(accessToken);
        if (payload.privacyPolicyAccepted) {
            navigate("/dashboard");
        }
    } else {
        navigate("/signin");
    }

    return (
        <StyledPrivacyPolicyLayout>
            <Flex>
                <div className="container">
                    <div>
                        <Flex $justify="space-between" $align="center" className="header">
                            <Logo color="#0B93E3"/>
                            <Select<Option>
                                options={options}
                                value={selectedLanguage}
                                onChange={handleLanguageChange}
                                classNamePrefix="react-select"
                                isSearchable={false}
                            />
                        </Flex>
                        <Flex $align="center" onClick={handleLogout} className="go-back-btn">
                            <Arrow/>
                            <div className="link">{t('auth.privacyPolicy.goBackBtn')}</div>
                        </Flex>
                    </div>
                    <Flex $align="center" $direction="column" className="form">
                        {children}
                    </Flex>
                </div>
                <div className="image-wrapper">
                    <img className="backgroundImage" src={Background} alt="auth-background" />
                </div>
            </Flex>
        </StyledPrivacyPolicyLayout>
    );
};
